import React from 'react';
import { MastercardLogo as BaseMastercardLogo } from '@move-frontend/form';
import { useTranslationForType } from '../hooks/useTranslationForType';
import { CreditCardType } from '../../../domain/models';

export const MastercardLogo = () => {
	const alt = useTranslationForType(CreditCardType.Mastercard);

	return <BaseMastercardLogo alt={alt} />;
};
